import { Avatar, message } from "antd";
import { FC, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  deleteIconSVG,
  lCHarSVG,
  serviceSVG,
} from "../../../../../assets/SVGs/SVGs";
import { getAvailableTeamMembersByServices } from "../../../../../network/teamMember";
import { UserOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import {
  appointmentPackage,
  appointmentService,
  availableTeamMember,
} from "../../../../../types/calendar";

import Services from "./Services";
import Packages from "./Packages";

interface ServicesAndPackagesProps {
  packages: appointmentPackage[];
  setPackages: React.Dispatch<React.SetStateAction<appointmentPackage[]>>;
  services: appointmentService[];
  setServices: (services: appointmentService[]) => void;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  dateAndTime: {
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  };
  clientPreferredGender: string | null;
}

const ServicesAndPackages: FC<ServicesAndPackagesProps> = ({
  services,
  setServices,
  packages,
  setPackages,
  dateAndTime,
  step,
  setStep,
  clientPreferredGender,
}) => {
  const intl = useIntl();
  const [searchValue, setSearchValue] = useState("");
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => state.calendar
  );

  const { data: teamMembers } = useQuery(
    [
      "availableTeamMembers",
      services,
      packages,
      dateAndTime,
      step,
      clientPreferredGender,
    ],

    () => {
      if (step > 1 && step < 4) {
        return getAvailableTeamMembersByServices({
          locationId: locationId,
          date: dayjs(dateAndTime?.date).format("YYYY-MM-DD"),
          start_time: dateAndTime?.startTime,
          pricing_option_ids: services.map((service) => service.id),
          package_ids: packages.map((packageItem) => packageItem.id),
          available_for: "both",
          // available_for:
          //   clientPreferredGender === "female"
          //     ? "woman"
          //     : clientPreferredGender === "male"
          //     ? "man"
          //     : clientPreferredGender || "both",
        });
      }
      return { data: false };
    },
    { select: (res) => res?.data }
  );

  const getTeamMembersOptions = (id: number, type: "service" | "package") => {
    if (!teamMembers?.length) {
      return [];
    }
    const filteredTeamMembers = teamMembers?.filter(
      (member: availableTeamMember) =>
        (type === "service" && member?.service_id?.includes(id)) ||
        (type === "package" && member?.package_id?.includes(id))
    );
    const temMembersOptions =
      filteredTeamMembers?.map((option: availableTeamMember) => {
        return {
          label: (
            <div className="flex items-center justify-between gap-2 px-2 ">
              <div className="flex gap-2 items-center w-full">
                <Avatar
                  size={30}
                  src={option?.media}
                  className="bg-color-primary"
                  icon={<UserOutlined color="#fff" />}
                >
                  {option?.name?.charAt(0)}
                </Avatar>
                <p className=" ">{option?.name}</p>
              </div>
            </div>
          ),
          key: String(option?.id),
          value: String(option?.id),
        };
      }) || [];
    if (temMembersOptions.length > 0) {
      temMembersOptions.unshift({
        label: (
          <div className="flex items-center justify-between gap-2 px-2 ">
            <div className="flex gap-2 items-center w-full">
              <Avatar size={30} className="bg-color-primary">
                {lCHarSVG}
              </Avatar>
              <p className=" ">
                {intl.formatMessage({
                  id: "lookfindrSuggestion",
                  defaultMessage: "إختيار لوكفايندر",
                })}
              </p>
            </div>
          </div>
        ),
        key: filteredTeamMembers[0]?.id,
        value: filteredTeamMembers[0]?.id,
      });
    }
    return temMembersOptions;
  };
  const removeServicesItem = (index: number) => {
    const newServices = services.filter((_, i) => i !== index);
    if (newServices.length === 0 && packages?.length === 0) {
      setStep(1);

      message.error(
        intl.formatMessage({
          id: "servicesRequiredOne",
          defaultMessage: "يجب عليك تحديد خدمة واحدة على الاقل",
        })
      );
    }
    setServices(newServices);
  };
  const removePackagesItem = (index: number) => {
    const newPackages = packages.filter((_, i) => i !== index);
    if (newPackages.length === 0 && services?.length === 0) {
      setStep(1);

      message.error(
        intl.formatMessage({
          id: "servicesRequiredOne",
          defaultMessage: "يجب عليك تحديد خدمة واحدة على الاقل",
        })
      );
    }
    setPackages(newPackages);
  };

  const handleSelectTeamMember = (
    id: number,
    teamMemberId: number | "lookfindr",
    type: "service" | "package"
  ) => {
    if (!teamMemberId) return;
    if (teamMemberId === "lookfindr") {
    }

    if (type === "service") {
      const newServices = services.map((service) => {
        if (service.id === id) {
          return {
            ...service,
            teamMemberId: +teamMemberId,
          };
        }
        return service;
      });
      setServices(newServices);
      return;
    }
    if (type === "package") {
      const newPackages = packages.map((pkg) => {
        if (pkg.id === id) {
          return {
            ...pkg,
            teamMemberId: +teamMemberId,
          };
        }
        return pkg;
      });
      setPackages(newPackages);
      return;
    }
  };

  return (
    <div className=" p-2 bg-white space-y-4 ">
      <Services
        step={step}
        setStep={setStep}
        services={services}
        setServices={setServices}
        removeServicesItem={removeServicesItem}
        handleSelectTeamMember={handleSelectTeamMember}
        getTeamMembersOptions={getTeamMembersOptions}
        locationId={locationId}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />

      <Packages
        getTeamMembersOptions={getTeamMembersOptions}
        handleSelectTeamMember={handleSelectTeamMember}
        locationId={locationId}
        setPackages={setPackages}
        packages={packages}
        removePackageItem={removePackagesItem}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        setStep={setStep}
        step={step}
      />
    </div>
  );
};

export default ServicesAndPackages;
